//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './CmsPageVersionClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchCmsPageVersionQueryParameters = {
  pageId?: number | null | undefined ;
  searchByUser?: string | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type GetVersionDetailsCmsPageVersionQueryParameters = {
  id: number ;
}

export type PublishVersionCmsPageVersionQueryParameters = {
  id: number ;
}

export type DeleteVersionCmsPageVersionQueryParameters = {
  id: number ;
}

export function searchUrl(pageId?: number | null | undefined, searchByUser?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/cms-pages/versions?";
if (pageId !== undefined && pageId !== null)
    url_ += "PageId=" + encodeURIComponent("" + pageId) + "&";
if (searchByUser === null)
    throw new Error("The parameter 'searchByUser' cannot be null.");
else if (searchByUser !== undefined)
    url_ += "SearchByUser=" + encodeURIComponent("" + searchByUser) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfCmsPageVersionDto, unknown, Types.PagedResultOfCmsPageVersionDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfCmsPageVersionDto, unknown, Types.PagedResultOfCmsPageVersionDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchCmsPageVersionQueryParameters): QueryKey;
export function searchQueryKey(pageId?: number | null | undefined, searchByUser?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { pageId, searchByUser, offset, limit, sortBy, sortOrder,  } = params[0] as SearchCmsPageVersionQueryParameters;

    return trimArrayEnd([
        'CmsPageVersionClient',
        'search',
        pageId as any,
        searchByUser as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'CmsPageVersionClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfCmsPageVersionDto, TError = unknown>(dto: SearchCmsPageVersionQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfCmsPageVersionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Searches CMS page versions
 * @param pageId (optional) 
 * @param searchByUser (optional) Substring must be in the login(userName) or firstName
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useSearchQuery<TSelectData = Types.PagedResultOfCmsPageVersionDto, TError = unknown>(pageId?: number | null | undefined, searchByUser?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfCmsPageVersionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfCmsPageVersionDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfCmsPageVersionDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let pageId: any = undefined;
  let searchByUser: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ pageId, searchByUser, offset, limit, sortBy, sortOrder,  } = params[0] as SearchCmsPageVersionQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [pageId, searchByUser, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfCmsPageVersionDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(pageId, searchByUser, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfCmsPageVersionDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Searches CMS page versions
 * @param pageId (optional) 
 * @param searchByUser (optional) Substring must be in the login(userName) or firstName
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfCmsPageVersionDto | undefined) => Types.PagedResultOfCmsPageVersionDto, pageId?: number | null | undefined, searchByUser?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(pageId, searchByUser, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Searches CMS page versions
 * @param pageId (optional) 
 * @param searchByUser (optional) Substring must be in the login(userName) or firstName
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfCmsPageVersionDto | undefined) => Types.PagedResultOfCmsPageVersionDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getVersionDetailsUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/cms-pages/versions/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getVersionDetailsDefaultOptions: Omit<UseQueryOptions<Types.CmsPageVersionDetailedDto, unknown, Types.CmsPageVersionDetailedDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CmsPageVersionDetailedDto, unknown, Types.CmsPageVersionDetailedDto>, 'queryFn'>> = {
};
export function getGetVersionDetailsDefaultOptions() {
  return getVersionDetailsDefaultOptions;
};
export function setGetVersionDetailsDefaultOptions(options: typeof getVersionDetailsDefaultOptions) {
  getVersionDetailsDefaultOptions = options;
}

export function getVersionDetailsQueryKey(id: number): QueryKey;
export function getVersionDetailsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetVersionDetailsCmsPageVersionQueryParameters;

    return trimArrayEnd([
        'CmsPageVersionClient',
        'getVersionDetails',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'CmsPageVersionClient',
        'getVersionDetails',
        ...params
      ]);
  }
}
export function __getVersionDetails(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getVersionDetails(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetVersionDetailsQuery<TSelectData = Types.CmsPageVersionDetailedDto, TError = unknown>(dto: GetVersionDetailsCmsPageVersionQueryParameters, options?: Omit<UseQueryOptions<Types.CmsPageVersionDetailedDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets detailed information about a specific CMS page version
 */
export function useGetVersionDetailsQuery<TSelectData = Types.CmsPageVersionDetailedDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.CmsPageVersionDetailedDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetVersionDetailsQuery<TSelectData = Types.CmsPageVersionDetailedDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CmsPageVersionDetailedDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetVersionDetailsCmsPageVersionQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CmsPageVersionDetailedDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getVersionDetails(context, axiosConfig) : __getVersionDetails,
    queryKey: getVersionDetailsQueryKey(id),
    ...getVersionDetailsDefaultOptions as unknown as Omit<UseQueryOptions<Types.CmsPageVersionDetailedDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets detailed information about a specific CMS page version
 */
export function setGetVersionDetailsData(queryClient: QueryClient, updater: (data: Types.CmsPageVersionDetailedDto | undefined) => Types.CmsPageVersionDetailedDto, id: number) {
  queryClient.setQueryData(getVersionDetailsQueryKey(id),
    updater
  );
}

/**
 * Gets detailed information about a specific CMS page version
 */
export function setGetVersionDetailsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CmsPageVersionDetailedDto | undefined) => Types.CmsPageVersionDetailedDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function publishVersionUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/cms-pages/versions/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function publishVersionMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CmsPageVersionClient',
      'publishVersion',
      id as any,
    ]);
}

/**
 * Publishes a specific CMS page version
 */
export function usePublishVersionMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = publishVersionMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.publishVersion(id),
    mutationKey: key,
  });
}
  
type PublishVersion__MutationParameters = PublishVersionCmsPageVersionQueryParameters

/**
 * Publishes a specific CMS page version
 */
export function usePublishVersionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PublishVersion__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PublishVersionCmsPageVersionQueryParameters}): UseMutationResult<void, unknown, PublishVersion__MutationParameters, TContext> {
  const key = publishVersionMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PublishVersion__MutationParameters) => Client.publishVersion(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function deleteVersionUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/cms-pages/versions/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteVersionMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CmsPageVersionClient',
      'deleteVersion',
      id as any,
    ]);
}

/**
 * Deletes a specific CMS page version
 */
export function useDeleteVersionMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteVersionMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteVersion(id),
    mutationKey: key,
  });
}
  
type DeleteVersion__MutationParameters = DeleteVersionCmsPageVersionQueryParameters

/**
 * Deletes a specific CMS page version
 */
export function useDeleteVersionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteVersion__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteVersionCmsPageVersionQueryParameters}): UseMutationResult<void, unknown, DeleteVersion__MutationParameters, TContext> {
  const key = deleteVersionMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteVersion__MutationParameters) => Client.deleteVersion(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}